import client from "./client";

const textCard = (card = {}) => ({
  title: card.title || "",
  description: card.description || "",
});

const offeringCard = (card = {}) => ({
  label: card.label || "",
  title: card.title || "",
  description: card.description || "",
});

const processCard = (card = {}) => ({
  step: card.step || "",
  title: card.title || "",
  time: card.time || "",
  description: card.description || "",
  tags: Array.isArray(card.tags)
    ? card.tags.map((tag) => String(tag || "")).filter(Boolean)
    : [],
});

const techCard = (card = {}) => ({
  title: card.title || "",
  items: Array.isArray(card.items)
    ? card.items.map((item) => String(item || "")).filter(Boolean)
    : [],
});

const TEXT_KEYS = [
  "heroTag",
  "heroTitle1",
  "heroTitle2",
  "heroDescription",
  "heroPrimaryCtaText",
  "heroPrimaryCtaLink",
  "heroSecondaryCtaText",
  "heroSecondaryCtaLink",
  "heroTrustText",
  "offeringsTag",
  "offeringsTitle1",
  "offeringsTitle2",
  "offeringsSubtitle",
  "processTag",
  "processTitle1",
  "processTitle2",
  "processSubtitle",
  "techTag",
  "techTitle1",
  "techTitle2",
  "techSubtitle",
];

const BOOL_KEYS = [
  "heroSectionHide",
  "offeringsHide",
  "processHide",
  "techHide",
];

const OFFERING_KEYS = [
  "offering1",
  "offering2",
  "offering3",
  "offering4",
  "offering5",
  "offering6",
];

const PROCESS_KEYS = [
  "processStep1",
  "processStep2",
  "processStep3",
  "processStep4",
  "processStep5",
  "processStep6",
];

const TECH_KEYS = [
  "techGroup1",
  "techGroup2",
  "techGroup3",
  "techGroup4",
  "techGroup5",
  "techGroup6",
  "techGroup7",
  "techGroup8",
  "techGroup9",
];

export function prepareServicePage(form = {}) {
  const payload = {};

  TEXT_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = form[key] ?? "";
  });
  BOOL_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = !!form[key];
  });

  if (form.heroLogoCard !== undefined) {
    payload.heroLogoCard = {
      image: form.heroLogoCard?.image || "",
      text: form.heroLogoCard?.text || "",
    };
  }
  if (form.heroCard1 !== undefined) payload.heroCard1 = textCard(form.heroCard1);
  if (form.heroCard2 !== undefined) payload.heroCard2 = textCard(form.heroCard2);

  OFFERING_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = offeringCard(form[key]);
  });
  PROCESS_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = processCard(form[key]);
  });
  TECH_KEYS.forEach((key) => {
    if (form[key] !== undefined) payload[key] = techCard(form[key]);
  });

  return payload;
}

export const getServicePage = () => client.post("/servicepage/getPage");
export const updateServicePage = (payload) =>
  client.post("/servicepage/updatePage", payload);
